/// <reference types="@types/ckeditor" />
import {from as observableFrom, of as observableOf,  Observable, Subject, Subscription } from 'rxjs';

import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ViewEncapsulation, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CKEditorComponent } from 'ckeditor4-angular';
import { CKEditor4 } from 'ckeditor4-angular/ckeditor';
import { DomSanitizer } from '@angular/platform-browser'
import * as srcDoc from 'srcdoc-polyfill';

import { environment } from '../../../../environments/environment'

import { EmailPackage } from './email-tree/email-package';
import { NotificationService, EmailAuditPackages, EmailMessages, FailedPassedEmailPackage, UserProfileService, UpdateStateService, updateSend, emailTemplate } from '../../../core';
import { SafeHtml } from '@angular/platform-browser';
import { SelectDlgRecipientVM, SelectDlgMode, ProgressInfo } from './select-dlg/select-dlg.component';
import { ConfirmDialogComponent } from '../../../common/component/confirm-dialog/confirm-dialog.component';
import { AlertComponent } from '../../../common/component/alert/alert.component';
import { AbstractControl, ControlContainer, FormControl, FormControlDirective, NgModel } from '@angular/forms';
enum TypeofEdit { none, toggleProperty, editMessage };

@Component({
  selector: 'app-reviewer',
  templateUrl: './reviewer.component.html',
  styleUrls: ['./reviewer.component.scss']
})
export class ReviewerComponent implements OnInit, OnDestroy {

  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent
  @ViewChild('emailTo', { static: false }) emailTo: NgModel;
  @ViewChild(CKEditorComponent, { static: true }) ck:CKEditorComponent;

  constructor(
    private route: ActivatedRoute
    , private sanitized: DomSanitizer
    , private notificationService: NotificationService
    , private userProfileService: UserProfileService
    , private updateStateService: UpdateStateService<ProgressInfo>
    , private router: Router
  ) {
  }
  beginTemplate: string = emailTemplate.beginTemplate;
  endTemplate: string = emailTemplate.endTemplate;
  ckEditorUrl:string = environment.baseWebApiUrl + "Scripts/ckeditor/ckeditor.js";//environment.baseWebApiUrl+"Scripts/ckeditor/ckeditor.js"
  riApp:string;
  expanded:boolean=true;
  passedPackageTitle:string="Passed Audit Packages";
  ngOnInit() {

    this.passedPackageTitle="Passed Audit Packages";
    let snapshot = this.route.snapshot;
     this.riApp = snapshot.parent.url["0"].path; //one of rateAudit, rateAvailability or reverseAudit
    this.auditType = this.riAppNotifTypeMap.find(v => v.path == this.riApp).notifAuditType;
    this.auditID = snapshot.params.auditId;
    this.universalID = snapshot.params.universalId;
    this.accountName = snapshot.params.accountName;
    if (this.riApp == "rateAudit") {
    }
    else if (this.riApp == "rateAvailability") {
      this.auditID = snapshot.params.scheduleId;
    }
    else if (this.riApp == "reverseAudit") {
      this.auditID = snapshot.params.auditRvrId;
      this.expanded=false;
      this.passedPackageTitle="Reverse Audit Notification"
    }
    this.GetEmailPackages(() => { });
  }
  UpdateSendEnabled() {
    this.All.forEach(pckage => pckage.SendEnabled = !(pckage.Sent || (pckage.EmailMessages.length>0  && pckage.EmailMessages.every(m => !m.IncludeInPackage))));
  }
  GetEmailPackages(onComplete: () => void) {
    this.showSpinner = true;
    this.notificationService.GetEmailAuditPackages(this.auditID, this.auditType).pipe(
      finalize(() => {
        this.showSpinner = false;
        onComplete();
      }))
      .subscribe(data => {
        if (data) {
          this.emailAuditPackages = data;
          this.UpdateSendEnabled();
        } else {
          this.userProfileService.CheckAndHandleSessionTimeout();
        }
      }, (err) => { console.log(err); });
  }
  ngOnDestroy() {
    let editor = this.getCkeditor();
    if (editor) {
      //not needed editor.destroy();
    }
  }
  any(list: EmailAuditPackages[]): boolean {
    if(this.riApp!="reverseAudit"){
      return list.some(r => !r.Sent && r.SendEnabled && r.EmailMessages.some(d => d.IncludeInPackage));
    }
    else{
      return list.some(r => !r.Sent && r.SendEnabled);
    }
  }

  ckEditEvent(event:CKEditor4.EventInfo, name, ctrl) {
    console.log("ckEditEvent "+ name)
    var mode = event.editor.mode;//wysiwig or source
    if(event.name === 'instanceReady'){
      let type = this.ck.type;
      //let ckeditor = (<any>window).CKEDITOR;
      if(CKEDITOR){
        let ckeditor = CKEDITOR;
        ckeditor.config.height = 400;
      }
    }
    if (name === 'ready') {
      //save instance
      this.ckeditor = event.editor;
      this.CKdocument = this.ckeditor.document;
    } else if (name == "change") {
      let dis = this;
      let rtn = this.CKdocument.appendStyleText(this.stylesStr);
      dis.showSpinner = false;
      let rtn2 = this.CKdocument.getHead().getText();

    }
  }
  IfNotInProdRemoveNonCventRecipients(): Observable<boolean> {

    if (!environment.production) {
      let deletingEmail = false;
      let partialList: string[] = [];
      let parialCnt = 10;
      let packageList: EmailAuditPackages[] = [];
      let packageListToSend: EmailAuditPackages[] = [];
      let partialListToSend: string[] = [];
      this.All.forEach(p => {
        if (p.SendEnabled && p.ToEMailAddress && p.ToEMailAddress.length > 0 && this.riApp!="reverseAudit") {
          let list = p.ToEMailAddress.split(";");
          if (list.some(s => !(s.toLowerCase().endsWith('@j.mail')
                            || s.toLowerCase().endsWith('@l.mail')
                            || s.toLowerCase().endsWith('@k.mail')
                            || (s.toLowerCase().endsWith('@cvent.com') && environment.enableCventmail)
          ))
          ) {
            deletingEmail = true;
            packageList.push(p);
            if (parialCnt-- > 0) {
              partialList.push(p.ToEMailAddress);
            }
          }
        }

        if (this.riApp=="reverseAudit" && p.ToEMailAddress && p.ToEMailAddress.length > 0) {
          let list = p.ToEMailAddress.split(";");
          if (list.some(s => !(s.toLowerCase().endsWith('@j.mail')
                            || s.toLowerCase().endsWith('@l.mail')
                            || (s.toLowerCase().endsWith('@cvent.com') && environment.enableCventmail)
                            ))) {
              deletingEmail = true;
              if(p.SendEnabled){
                packageList.push(p);
                partialList.push(p.ToEMailAddress);
              }
          }
          else{
            if(p.SendEnabled){
              packageListToSend.push(p);
              partialListToSend.push(p.ToEMailAddress);
            }
          }

         }
      })
      if (deletingEmail) {
        let done = new Subject<boolean>();
        this.confirmDialog.confirm("Because you are running on a system outside of production, only  @j.mail, or @cvent.com in ct50, e-mail addresses are permitted."
          , "These e-mail address will be disabled\r\n\r\n" + partialList.join("\r\n"), "Invalid Emails")
          .subscribe(ok => {
            if (ok) {
              packageList.forEach(p => p.SendEnabled = false);
              if(this.riApp=="reverseAudit"){
                packageListToSend.forEach(p => p.SendEnabled = true);
              }
              done.next(true);
            } else {
              done.next(false);
            }
          }, (err) => { console.log(err); done.next(false) });
        return done.asObservable();
      } else {
        let rtn:boolean = true;
        return observableOf(rtn);
      }
    }
    let rtn:boolean = true;
    return observableOf(rtn);
}

  StartSendNotificationsProcess() {
    let s1 = this.IfNotInProdRemoveNonCventRecipients().pipe(
      finalize(() => s1.unsubscribe()))
      .subscribe(ok => {
        if (ok)
          this.PreparePackagesForSendNotificationsConfirmation();
      });
  }
  async SendPackagesProcess() {
    let progress:ProgressInfo = { current: 0, total: this.All.length, message: "Initializing" };
    this.updateStateService.updateState(progress);
    let packageList = this.All.filter(p => p.SendEnabled && !p.Sent);
    progress.total = packageList.length;
    this.updateStateService.updateState(progress);
    let working = observableFrom(packageList);
    let done = false;
    this.errorWhileSendingNotifications = "";

    for (let pckage of packageList) {
      progress.current++;
      progress.message = pckage.ToEMailAddress;
      this.updateStateService.updateState(progress);

      var rtn = this.notificationService.SendNotification(pckage.NotificationID)
        .toPromise();
      var msgResult = await rtn;
      if (!msgResult.success) {
        this.errorWhileSendingNotifications = "Error sending notification for " + pckage.ToEMailAddress + ", process stopped.";
        progress.current = progress.total + 1;
        this.updateStateService.updateState(progress);
        break;
      }
    }
    progress.message = "done";
    progress.current = progress.total + 1;
    this.updateStateService.updateState(progress);
  }
  errorWhileSendingNotifications:string = "";
  PreparePackagesForSendNotificationsConfirmation() {

    //first remove IncludeInPackage for those not set to SendEnabled
    let thoseToUpdateFirst = this.All.filter(r => (!r.Sent && !r.SendEnabled && r.EmailMessages.some(sr => sr.IncludeInPackage == true)));

    if (thoseToUpdateFirst.length > 0) {
      let emailMessages: EmailMessages[] = [];
      thoseToUpdateFirst.forEach(r => {
        r.EmailMessages.forEach(sr => {
          if (sr.IncludeInPackage) {
            sr.IncludeInPackage = false;
            emailMessages.push(sr);
          }
        });
      });

      this.showSpinner = true;
      this.notificationService.UpdateNotificationPackage(this.auditID, emailMessages, this.auditType, this.typeOfEdit.toString())
        .subscribe(rtn => {
          this.showSpinner = false;
          if (rtn.success) {
            this.ShowConfirmationList();
          } else {
            this.confirmDialog.confirm("Error while updating packages ", "", "Service Error").subscribe(
              ok => this.GetEmailPackages(() => { })
            );
          }
        }, (err) => { this.showSpinner = false; console.log(err); });
    } else {
      this.ShowConfirmationList();
    }
  }

  CreateConfirmMsgs(selectDialogList: SelectDlgRecipientVM[], packages: EmailAuditPackages[], msg1: string, msg2: string) {
        packages.forEach(recip => {
          if (recip.SendEnabled && !recip.Sent ) {
            let cnt = 0;
            recip.EmailMessages.forEach(r => cnt += (r.IncludeInPackage ? 1 : 0));
            selectDialogList.push({ selected: true, display: msg1 + " Audit " + msg2 + " : " + recip.ToEMailAddress + " (" + cnt + ")", emailMessages: null, package: recip });
          }
        });
  }

  ShowConfirmationList() {
    this.selectDlgMode = SelectDlgMode.finalConfirmMode;

    this.selectDialogList = [];
    if(this.riApp!=="reverseAudit"){
    this.CreateConfirmMsgs(this.selectDialogList, this.dataFailedTo, "Failed", "TO");
    this.CreateConfirmMsgs(this.selectDialogList, this.dataFailedCc, "Failed", "CC");
    this.CreateConfirmMsgs(this.selectDialogList, this.dataFailedBcc, "Failed", "BCC");
    }
    this.CreateConfirmMsgs(this.selectDialogList, this.dataPassedTo, "Passed", "TO");
    this.CreateConfirmMsgs(this.selectDialogList, this.dataPassedCc, "Passed", "CC");
    this.CreateConfirmMsgs(this.selectDialogList, this.dataPassedBcc, "Passed", "BCC");


    this.showSelectDialog = true;
  }

  NotificationsComplete() {
    this.showSelectDialog = false;
    this.GetEmailPackages(() => {
      if (this.errorWhileSendingNotifications == "") {
        this.confirmDialog.confirm("All Messages Sent", "", "Done").subscribe();
      } else {
        this.confirmDialog.confirm(this.errorWhileSendingNotifications, "", "Error Processing Reqeust").subscribe();
      }
    });
  }

  ckeditor: CKEDITOR.editor;
  CKdocument: CKEDITOR.dom.document;

  auditID: string = "";
  auditType: number = 0;
  scheduleID: string = "";

  universalID: string = "";
  accountName: string = "";
  showSpinner: boolean = false;
  showModal: boolean = false;
  emailPattern:RegExp = new RegExp("^(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$","i");

  riAppNotifTypeMap = [{ path: 'rateAudit', notifAuditType: 1 }, { path: 'rateAvailability', notifAuditType: 2 }, { path: 'reverseAudit', notifAuditType: 3 }];

  set emailAuditPackages(data: FailedPassedEmailPackage) {

    if (data) {
      data.Failed.To.forEach(element => {
         element.EmailMessages.sort((a,b)=>{
          return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });
      data.Failed.Cc.forEach(element => {
         element.EmailMessages.sort((a,b)=>{
          return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });
      data.Failed.Bcc.forEach(element => {
          element.EmailMessages.sort((a,b)=>{
          return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });
      data.Passed.To.forEach(element => {
          element.EmailMessages.sort((a,b)=>{
           return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });
      data.Passed.Cc.forEach(element => {
          element.EmailMessages.sort((a,b)=>{
          return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });
      data.Passed.Bcc.forEach(element => {
        element.EmailMessages.sort((a,b)=>{
        return a.PropertyName.toLowerCase().localeCompare(b.PropertyName.toLowerCase());
        })
    });

      this.dataFailedTo = data.Failed.To;
      this.dataFailedCc = data.Failed.Cc;
      this.dataFailedBcc = data.Failed.Bcc;
      this.dataPassedTo = data.Passed.To;
      this.dataPassedCc = data.Passed.Cc;
      this.dataPassedBcc = data.Passed.Bcc;
      this.All = [];
      this.All.push(...this.dataFailedTo); //can't use concat it recreates, this maintains the references
      this.All.push(...this.dataFailedCc);
      this.All.push(...this.dataFailedBcc);
      this.All.push(...this.dataPassedTo);
      this.All.push(...this.dataPassedCc);
      this.All.push(...this.dataPassedBcc);
    }
  }
  All: EmailAuditPackages[] = [];
  dataFailedTo: EmailAuditPackages[] = [];
  dataFailedCc: EmailAuditPackages[] = [];
  dataFailedBcc: EmailAuditPackages[] = [];

  dataPassedTo: EmailAuditPackages[] = [];
  dataPassedCc: EmailAuditPackages[] = [];
  dataPassedBcc: EmailAuditPackages[] = [];

  expandAll(expand: boolean) {
    this.All.forEach(r => r.expanded = expand);
  }
  from: string = "";
  recipient: string = "";
  subject: string = "";
  ckeditorText: string = "";
  message: SafeHtml = "";
  showHeading: boolean = true;
  showSelectDialog: boolean = false;
  selectDlgMode: SelectDlgMode = SelectDlgMode.propertyMode;
  selectDialogList: SelectDlgRecipientVM[] = [];

  selectDialogApplyChanges() {
    if (this.selectDlgMode == SelectDlgMode.propertyMode) {
      this.applyPropertyOrEmailBodyChanges();
    } else if (this.selectDlgMode == SelectDlgMode.finalConfirmMode) {
      this.NotificationsComplete();
    }
  }
  updateNotificationPackage(submitList: EmailMessages[]){
    if (submitList.length > 0) {
      this.updateEnabledOnRecipients();
      this.notificationService.UpdateNotificationPackage(this.auditID, submitList, this.auditType, TypeofEdit.toggleProperty.toString()).pipe(
        finalize(() => {
          this.showSpinner = false;
          if(this.lastSelectedItem && <EmailAuditPackages>(this.lastSelectedItem).FromEmailAddress){
            this.selectRecipient( this.lastSelectedItem);
          }
        }))
        .subscribe(rtn => {
          if (!rtn.success) {
            this.userProfileService.CheckAndHandleSessionTimeout();
          }
        },
        err => { console.log(err); }
        );

    }
  }
  updateEnabledOnRecipients(){
    this.All.forEach(recipient => updateSend(recipient));
  }
  isRecipientEditable(){
    let EmailPackage = this.lastSelectedItem as EmailAuditPackages;

    if(EmailPackage
         && (EmailPackage.SendEnabled==true || EmailPackage.DeliveryFailed==true)){
      return true;
    }
    return false;
  }
  FindEmailPackage(notificationID:string):EmailAuditPackages{
    let rtn:EmailAuditPackages = null;
    let matching = this.All.filter( p => p.NotificationID == notificationID);
    if(matching.length == 1){
      rtn = matching[0];
    }
    return rtn;
  }
  CanSavePackageContent():boolean{
    let lastSelectedItem = this.lastSelectedItem;
    if (lastSelectedItem) {
      let emailMessages:EmailMessages = lastSelectedItem as EmailMessages;
      if(emailMessages){
        let parentPackage = this.FindEmailPackage(lastSelectedItem.NotificationID);
        return parentPackage.SendEnabled;
      }
    }
    return false;
  }
  onBlurRecipientEmail(event:FocusEvent){
    console.log("onBlurRecipientEmail");

    if(this.isRecipientEditable()){
      let EmailPackage = this.lastSelectedItem as EmailAuditPackages;
      if (this.emailTo.valid) {
        let newRecipient = this.emailTo.value;
        if(newRecipient && EmailPackage.ToEMailAddress !==newRecipient ) {
          console.log("onBlurRecipientEmail send update");
          let EmailPackages = this.All.filter(p =>
            (p.SendEnabled == true || !p.Sent || p.DeliveryFailed) && p.ToEMailAddress.toLowerCase()==EmailPackage.ToEMailAddress.toLowerCase() )
          this.showSpinner = true;
          this.notificationService.UpdateEmailToAddress(this.auditID, newRecipient, EmailPackages)
            .pipe(finalize(() => this.showSpinner = false))
            .subscribe( rtn =>
              {
                if (rtn.success) {
                  console.log("onBlurRecipientEmail update complete");
                  EmailPackages.forEach(p =>{
                    p.ToEMailAddress = newRecipient;
                    if(p.DeliveryFailed){
                      p.DeliveryFailed = false;
                      p.SendEnabled = true;
                      p.Sent = false;
                    }
                  });
                  this.alerter.showAlertMessage(3000,"Update succeeded",0);
                }
                else{
                  this.alerter.showAlertMessage(3000,"Failed to Update email address: "+ rtn.message,2);
                }
              },
              (err) => {this.alerter.showAlertMessage(3000,"Failed to Update email address for "+ newRecipient,2)}
            );
        }
      }
      else{
        this.alerter.showAlertMessage(3000,"Please enter a valid Email address",2)
        console.log("Please enter a valid Email address");
        event.preventDefault();
      }
      this.emailTo.valid
    }
  }
  applyPropertyOrEmailBodyChanges() {
    let editingEventSrc = this.editingEventSrc;
    let typeOfEdit = this.typeOfEdit;

    this.closeSelectDlg();
    if (typeOfEdit !== TypeofEdit.none) {
      let changeList = this.selectDialogList.filter(r => r.selected);
      changeList.forEach(r => {
        if (typeOfEdit === TypeofEdit.toggleProperty) {
          r.emailMessages.IncludeInPackage = !r.emailMessages.IncludeInPackage;
        }
      });
      let submitList = changeList.map(r => {
        let d = r.emailMessages;
        let n: EmailMessages = {
          AuditPropertyID: d.AuditPropertyID,
          IncludeInPackage: d.IncludeInPackage,
          NotificationID: d.NotificationID,
          NotificationTemplateID: d.NotificationTemplateID,
          NotificationMessageID: d.NotificationMessageID,
          PropertyName: d.PropertyName
        };
        return n;
      });
      this.showSpinner = true;
      if (typeOfEdit === TypeofEdit.toggleProperty) {
        this.updateNotificationPackage(submitList);
      } else if (typeOfEdit === TypeofEdit.editMessage) {
        let selectedEmailMessage = this.lastSelectedItem as EmailMessages;
        if (selectedEmailMessage.AuditPropertyID) {
          this.notificationService
            .UpdateEmailBody(this.ckeditorText, this.auditID, submitList, this.auditType, TypeofEdit.editMessage.toString()).pipe(
            finalize(() => this.showSpinner = false))
            .subscribe(rtn => {
              if (!rtn.success) {
                this.userProfileService.CheckAndHandleSessionTimeout();
              }
            },
            (err) => { console.log(err); }

            );
        }
      }
    }
  }
  closeSelectDlg() {
    this.showSelectDialog = false;
    this.editingEventSrc = null;
    this.typeOfEdit = TypeofEdit.none;

  }
  saveTemplateEditing() {
    this.typeOfEdit = TypeofEdit.editMessage;
    let selectedEmailMessage = this.lastSelectedItem as EmailMessages;
    this.editingEventSrc = selectedEmailMessage;
    this.BuildSelectDialogList(selectedEmailMessage, true);
    this.selectDlgMode = SelectDlgMode.propertyMode;
    this.showSelectDialog = true;
  }
  get IE():boolean { return (<any>document).documentMode ? true : false };
  get Edge():boolean { return !this.IE && !!(<any>window).StyleMedia; };
  @ViewChild('frame', { static: true })
  public iframe:ElementRef;
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent; //nsf manually changed for compile error

  selectRecipient(event: EmailAuditPackages) {
    this.selectItem(event);
    this.from = event.FromEmailAddress;
    this.recipient = event.ToEMailAddress;
    this.subject = event.Subject;
    this.showHeading = true;
    this.showSpinner = true;
   this.notificationService.GetEmailMessage(event.NotificationID)
      .subscribe(data => {
        this.showSpinner = false;
        if (data) {
          //let url = this.router.url;
          //data = data.replace("<head>", '<head>\r\n<base href="http://localhost:4200'+url+'">');
          //data = data.replace('<a href="#', '<a href="'+url + '#' );
          data = data.replace(/<a href="#/g, '<a notHref="#');
          let madeSafe = this.sanitized.bypassSecurityTrustHtml(data);

          if (this.IE || this.Edge) {
            srcDoc.set(this.iframe.nativeElement, (<any>madeSafe).changingThisBreaksApplicationSecurity); //hack for IE
          } else {
            this.message = madeSafe;
          }
        } else {
          this.userProfileService.CheckAndHandleSessionTimeout();
        }
       }, (err) => { this.showSpinner = false; console.log(err); });
       var count=0;
       event.EmailMessages.forEach(element => {
         count= element.IncludeInPackage==true?count+1:count;
       });
       if(count==0 && this.riApp!="reverseAudit" )
       {
         this.alerter.showAlertMessage(3000, "All properties for the selected package have been removed. No Email will be sent to the selected address.", 2);
       }
  }
  lastSelectedItem: any;
  selectItem(item: any) {
    if (this.lastSelectedItem) {
      if (this.lastSelectedItem.selected)
        this.lastSelectedItem.selected = false;
    }
    this.lastSelectedItem = item;
    if(item){
      item.selected = true;
    }
    else{
      this.ckeditorText = "";
      this.message = "";
      this.from = "";
      this.recipient = "";
      this.subject = "";
      this.showHeading = true;
    }
  }
  tabSelect(index: number, title: string) {
    this.selectItem(null);
    console.log("tab select");
  }
  FaildOrPassedPackagePanelChanged(a:any){
    this.selectItem(null);
    console.log("FaildOrPassedPackagePanelChanged");
  }

  selectProperty(event: EmailMessages) {
     let mode = this.ck.instance.mode;
     if (mode === "source") {
      //start in wysiwg mode else full html with <html><head><body> is shown to user
      try {
        //alternate method this.ckeditor.execCommand('source');
/*  this results in a stack overflow for the server build, retry in later versions of angular and typescript
         this.ckeditor.setMode('wysiwyg', ()=>{
        console.log("wysiwyg set")
        this.handleSelectProperty(event);
      });
 */
      this.handleSelectProperty(event);
    } catch (error) {
        console.log(error);
      }
    }
    else{
      this.handleSelectProperty(event);
    }
  }

  stylesStr: string;
  private handleSelectProperty(event: EmailMessages) {
    this.selectItem(event);
    this.showSpinner = true;
    let s1 = this.notificationService.GetPropertyMessage(event.NotificationMessageID)
      .subscribe(emailDoc => {
        if (emailDoc) {
          this.showHeading = false;
          this.stylesStr = this.getNotificationStyles(emailDoc);
          let madeSafe = this.sanitized.bypassSecurityTrustHtml(emailDoc);

          this.ckeditor.resetUndo();
          this.ckeditorText = (<any>madeSafe).changingThisBreaksApplicationSecurity.replace("<title>Untitled</title>", '');
          console.log("fire('change')");
          this.ckeditor.fire('change'); //hack to force a change event when updated
        } else {
          this.userProfileService.CheckAndHandleSessionTimeout();
        }
      }, (err) => { this.showSpinner = false; console.log(err); }, () => this.showSpinner = false);
  }

  updateCkeditorStyle(emailDoc: string) {
    let marker = "\r\n onetimeInsert{-app-marker:not;}";
   // let ckeditor = CKEDITOR;
    let existing: string = this.ck.config.getCss();
    if (!existing.includes(marker)) {
      let stylesStr = this.getNotificationStyles(emailDoc);
      stylesStr = stylesStr.replace('border:solid 1px black;}', 'border:solid 1px black !important; }');
      let rtn = this.CKdocument.appendStyleText(stylesStr);
      let rtn2 = this.CKdocument.getHead().getText();
    }
  }
  typeOfEdit: TypeofEdit = TypeofEdit.none;
  editingEventSrc: EmailMessages;
  toggleProperty(mailMsg: EmailMessages) {
    this.BuildSelectDialogList(mailMsg, mailMsg.IncludeInPackage);
    this.typeOfEdit = TypeofEdit.toggleProperty;
    this.selectDlgMode = SelectDlgMode.propertyMode;
    this.editingEventSrc = mailMsg;
    if (this.selectDialogList.length > 1) {
      this.showSelectDialog = true;
    } else {
      this.applyPropertyOrEmailBodyChanges();//skip dialog, run directly thru the done process triggered by the select dialog
    }
  }
  BuildSelectDialogList(emailMessage: EmailMessages, stateToMatch: boolean) {
    let unsorted:SelectDlgRecipientVM[]=[];
    this.All.forEach(recip => {
      if (!recip.Sent ) {
        recip.EmailMessages.forEach(r => {
          if (r.AuditPropertyID == emailMessage.AuditPropertyID
            && r.IncludeInPackage == stateToMatch) {
            unsorted.push({ selected: true, display: recip.ToEMailAddress, emailMessages: r, package: recip });
          }
        });
      }
    });
    this.selectDialogList = unsorted.sort((a,b)=>{ return a.display.toLowerCase().localeCompare(b.display.toLowerCase());})
  }
  getNotificationStyles(data: string): string {
    let first = data.indexOf('.DataGridStyle');
    if (first != -1) {
      let end = data.indexOf('</style>', first);
      if (end != -1) {
        return data.substring(first, end);
      }
    } else {
      let srch = '<style type="text/css">';
      first = data.indexOf(srch);
      if (first != -1) {
        first = first + srch.length;
        let end = data.indexOf('</style>', first);
        if (end != -1) {
          return data.substring(first, end);
        }
      }
    }
    return '';
  }
  getCkeditor(): any {
    if (this.ckeditor)
      return this.ckeditor;

    //fallback to previous method
    let ckeditor = CKEDITOR;
    let editor;
    //there should only be one editor
    //so grab the first propert after some basic checking
    //and break out of the for loop
    for (let prop in ckeditor.instances) {
      if (prop.match(/^editor/)) {
        editor = ckeditor.instances[prop];
      }
    }
    return editor;
  }
  click() {
    let editor = this.getCkeditor();
    if (editor) {
      editor.insertHtml('');
    }
  }
}

